export default {
  data() {
    return {
    };
  },
  computed: {
    filteredMessage() {
      return this.sanitize(this.message.message);
    },

    imageUrl() {
      if (!this.message.user) return `https://ui-avatars.com/api/?background=eeeeee&font-size=0.4&color=3D70FF&size=100&name=${this.fullName}`;
      return this.message.user.image || `https://ui-avatars.com/api/?background=eeeeee&font-size=0.4&color=3D70FF&size=100&name=${this.fullName}`;
    },

    fullName() {
      if (this.message.type === 'inbound') return this.message.contact.fullName;
      return this.message.user.fullName;
    },
  },
  props: ['message'],
  template: `<div class="message shadow">
                <div class="thumbnail" v-if="message.type !== 'inbound'">
                  <img v-bind:src="imageUrl"/>
                </div><!--

                --><div class="message-text">
                  <div class="name">
                    {{ fullName }}
                  </div><div class="date">{{ message.created_at | moment('D-M HH:mm')}}</div> <br/>
                  <div class="message-body" v-html="filteredMessage"></div><br/>
                </div><!--
                
                --><div class="thumbnail" v-if="message.type === 'inbound'">
                  <img v-bind:src="imageUrl"/>
                </div>
              </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Message.js